import { useState } from 'react';

const DashboardNavigationBar = ({ onSelect, accessTms }) => {
  const [activeItem, setActiveItem] = useState("Newsfeed");

  const handleItemClick = (itemName) => {
    setActiveItem(itemName);
    onSelect(itemName);
  };

  return (
    <div className="myk__dashboard-mobile_nav-item">
      <ul>
        <li className={activeItem === "Newsfeed" ? "active" : ""}>
          <a
            onClick={() => handleItemClick("Newsfeed")}
            href="#"
            className={activeItem === "Newsfeed" ? "is-active" : ""}
          >
            Newsfeed
          </a>
        </li>
        <li className={activeItem === "My Learning" ? "active" : ""}>
          <a
            onClick={() => handleItemClick("My Learning")}
            href="#"
            className={activeItem === "My Learning" ? "is-active" : ""}
          >
            My Learning
          </a>
        </li>
        {!accessTms &&
        <li className={activeItem === "Upcoming Events" ? "active" : ""}>
          <a
            onClick={() => handleItemClick("Upcoming Events")}
            href="#"
            className={activeItem === "Upcoming Events" ? "is-active" : ""}
          >
            Upcoming Events
          </a>
        </li>
        }
        <li className={activeItem === "Reminders" ? "active" : ""}>
          <a
            onClick={() => handleItemClick("Reminders")}
            href="#"
            className={activeItem === "Reminders" ? "is-active" : ""}
          >
            Reminders
          </a>
        </li>
      </ul>
    </div>
  );
};

export default DashboardNavigationBar;
